import axios from 'axios/dist/axios';


const defaultState = {
    productList: [],
    sponsorList: [],
    selectedProductCode: null,
    mustShowActivationCodePopup: false,
    mustShowTryAgainInvalid: false,
    mustShowTryAgainExpired: false,
    mustShowTryAgainActivated: false,
    mustShowFullQuestion: true,
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    productList:                    defaultState.productList,
    sponsorList:                    defaultState.sponsorList,
    selectedProductCode:            defaultState.selectedProductCode,
    mustShowActivationCodePopup:    defaultState.mustShowActivationCodePopup,
    mustShowTryAgainInvalid:        defaultState.mustShowTryAgainInvalid,
    mustShowTryAgainExpired:        defaultState.mustShowTryAgainExpired,
    mustShowTryAgainActivated:      defaultState.mustShowTryAgainActivated,
    mustShowFullQuestion:           defaultState.mustShowFullQuestion
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getProductList: state => state.productList,
    getSponsorList: state => state.sponsorList,
    getSelectedProductCode: state => state.selectedProductCode,
    getMustShowActivationCodePopup: state => state.mustShowActivationCodePopup,
    getMustShowTryAgainInvalid: state => state.mustShowTryAgainInvalid,
    getMustShowTryAgainExpired: state => state.mustShowTryAgainExpired,
    getMustShowTryAgainActivated: state => state.mustShowTryAgainActivated,
    getMustShowFullQuestion: state => state.mustShowFullQuestion
};


// ======================================================================
// Actions
// ======================================================================

const actions = {
    loadProductListPageData ({ commit }) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER  + '/productList');
            axiosRequest.then((response) => {
                commit('setProductList', response.data.products);
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    /**
     * Select a product and load initial Assessmeent data.
     * @param {Object} - commit, dispatch
     * @param {Number} productId
     * @return {Promise}
     */
    selectProduct ({commit, dispatch}, productCode) {
        commit('setSelectedProductCode', productCode);
    },

    resetSelectedProduct ({commit}) {
        commit('clearSelectedProductCode');
    },
    showActivationCodePopup({commit}) {
        // let promise = new Promise((resolve, reject) => {
        commit('setMustShowActivationCodePopup', true);
        //  commit('setMustShowTryAgain', false)
        //   });

        //  return promise;
    },
    // showTryAgain({commit}) {
    //     commit('setMustShowTryAgain', true)
    // }
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {
    setProductList (state, products) {
        state.productList = products;
    },
    setSponsorList (state, sponsors) {
        state.sponsorList = sponsors;
    },
    setSelectedProductCode (state, selectedProductCode) {
        state.selectedProductCode = selectedProductCode;
    },

    clearProductList (state) {
        state.productList = [];
    },
    clearSponsorList (state) {
        state.sponsorList = [];
    },
    clearSelectedProductCode (state) {
        state.selectedProductCode = null;
    },
    setMustShowActivationCodePopup (state, data) {
        state.mustShowActivationCodePopup = data;
    },
    setMustShowTryAgainInvalid(state, data) {
        state.mustShowTryAgainInvalid = data;
    },
    setMustShowTryAgainExpired(state, data) {
        state.mustShowTryAgainExpired = data;
    },
    setMustShowTryAgainActivated(state, data) {
        state.mustShowTryAgainActivated = data;
    },
    setMustShowFullQuestion (state, newVal) {
        state.mustShowFullQuestion = newVal;
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.productList                      = defaultState.productList;
        state.sponsorList                      = defaultState.sponsorList;
        state.selectedProductCode              = defaultState.selectedProductCode;
        state.mustShowActivationCodePopup      = defaultState.mustShowActivationCodePopup;
        state.mustShowTryAgainInvalid          = defaultState.mustShowTryAgainInvalid;
        state.mustShowTryAgainExpired          = defaultState.mustShowTryAgainExpired;
        state.mustShowTryAgainActivated        = defaultState.mustShowTryAgainActivated;
        state.mustShowFullQuestion             = defaultState.mustShowFullQuestion;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/pathfinder/standard-forms/PfProductListStore.js